// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("assets/img/bg-linkrow.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".before-bg[data-v-9dff9edc]{background:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") no-repeat top/cover}.two-column[data-v-9dff9edc]> div{display:flex;flex-direction:column;justify-content:space-between}@media (min-width:769px){.two-column[data-v-9dff9edc]> div{flex-direction:row}}.two-column[data-v-9dff9edc]> div>div{width:100%;padding-bottom:1rem}@media (min-width:769px){.two-column[data-v-9dff9edc]> div>div{width:40%}}", ""]);
// Exports
module.exports = exports;
